// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"default-src_app_shared_components_deals_offers-card_offers-card_component_ts-src_app_shared_e-fb052d":"236fc98b3af11de4","src_app_modules_travel_travel-routing_module_ts":"2e64700d3f07c5e4","src_app_modules_deals_deals-routing_module_ts":"474897de60e08937"}[chunkId] + ".js";
};